import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { ModulesSection } from './components/ModulesSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { TestimonialSection } from './components/TestimonialSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-brand-black text-brand-white font-sans selection:bg-brand-gold selection:text-brand-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <ModulesSection data-id="element-5" />
      <AudienceSection data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <TestimonialSection data-id="element-8" />
      <PricingCTA data-id="element-9" />

      <Footer data-id="element-10" />
    </main>;
}